export interface ActionSurfaceCapabilities {
  canEditNotes: boolean;
}

export const MENTOR_LIVE_CAPABILITIES: ActionSurfaceCapabilities = {
  canEditNotes: true,
};
